import React, { useState } from 'react';
import { Input, Row, Col, Tooltip, Form } from 'antd';
import { AimOutlined } from '@ant-design/icons';
import { MaskedInput } from 'antd-mask-input';
import { normalizeToSelect } from 'util/converters';
import { api, RemoteSelect } from '@unicus/react-ui-kit';
import FormManager from './FormManager';
import Maps from './Maps';

const { FormItem } = FormManager;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 9 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 15 }
  },
  labelAlign: 'left',
  colon: false
};

const Address = () => {
  const form = FormManager.useForm();

  const [state, setState] = useState({
    lastPostalCode: null,
    loadingAddress: false,
    map: {
      visible: false,
      text: ''
    }
  });

  const setAddress = (newAddress) => {
    form.setFieldsValue({
      address: {
        ...newAddress,
        city: normalizeToSelect(newAddress.city)
      }
    });
  };

  const findAddress = (postalCode) => {
    postalCode = postalCode.replace(/[^0-9.]/g, '');

    if (state.lastPostalCode === postalCode) {
      return;
    }

    setState({ ...state, lastPostalCode: postalCode, loadingAddress: true });

    api.fetch('localizations', { postalCode }).then(({ data }) => {
      setState({ ...state, loadingAddress: false });
      setAddress(
        data
          ? data.result
          : {
              street: null,
              number: null,
              district: null,
              additionalInformation: null,
              city: undefined
            }
      );
    });
  };

  const handlePostalCodeChange = (sender) => {
    const postalCode = sender.target.value.replace(/[^0-9.]/g, '');
    if (postalCode.length === 8) {
      findAddress(postalCode);
    }
  };

  const handleSelectMap = () => {
    let value = '';
    const { address } = form.getFieldsValue();
    const { street, district, city, longitude, latitude } = address;

    if (city && city?.label) {
      value = city?.label.toLowerCase().replaceAll(' ', '_');
    }

    if (street) {
      value += `_${street.toLowerCase().replaceAll(' ', '_')}`;
    }

    if (district) {
      value += `_${district.toLowerCase().replaceAll(' ', '_')}`;
    }

    setState({
      ...state,
      map: { ...state.map, visible: true, text: value, longitude, latitude }
    });
  };

  const handleSetPosition = ({ longitude, latitude }) => {
    const { address } = form.getFieldsValue();

    form.setFieldsValue({
      address: {
        ...address,
        longitude,
        latitude
      }
    });
  };

  const handleChangeMaps = (value) => {
    handleSetPosition(value);

    setState({
      ...state,
      map: { ...state.map, visible: false }
    });
  };

  return (
    <>
      <Row>
        <Col span={12}>
          <FormItem
            {...formItemLayout}
            name={['address', 'postalCode']}
            label="CEP"
            required
            hasFeedback={state.loadingAddress}
            validateStatus={state.loadingAddress ? 'validating' : undefined}
          >
            <MaskedInput
              onChange={handlePostalCodeChange}
              mask="11111-111"
              suffix={
                <Tooltip title="Ajustar a localização no mapa">
                  <AimOutlined onClick={handleSelectMap} />
                </Tooltip>
              }
            />
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            {...formItemLayout}
            name={['address', 'street']}
            label="Logradouro"
            required
          >
            <Input maxLength={100} />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem
            {...formItemLayout}
            name={['address', 'number']}
            label="Número"
            required
          >
            <Input maxLength={40} />
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            {...formItemLayout}
            name={['address', 'district']}
            label="Bairro"
            required
          >
            <Input maxLength={40} />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem
            {...formItemLayout}
            name={['address', 'additionalInformation']}
            label="Complemento"
          >
            <Input maxLength={100} />
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            {...formItemLayout}
            name={['address', 'city']}
            label="Cidade"
            required
          >
            <RemoteSelect resource="cities" />
          </FormItem>
        </Col>
      </Row>
      <Form.Item name={['address', 'longitude']} noStyle />
      <Form.Item name={['address', 'latitude']} noStyle />

      {state.map.visible ? (
        <Maps
          visible={state.map.visible}
          initialValue={state.map}
          onChange={handleChangeMaps}
          onCancel={() =>
            setState({ ...state, map: { ...state.map, visible: false } })
          }
        />
      ) : null}
    </>
  );
};

export default Address;
